import { render, staticRenderFns } from "./BulkReturnDiscrepancy.vue?vue&type=template&id=15568eed&"
import script from "./BulkReturnDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./BulkReturnDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports